import {
  Alert,
  Box,
  Dialog,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { AnchorDownloadButton } from "../../ui/anchor-button";
import { useUserContext } from "../../../services/context/user-context";

// svg
import { ReactComponent as IconDownloadFile } from "../../../assets/svg/download-file.svg";
import { ReactComponent as IconClose } from "../../../assets/svg/x.svg";


export const DownloadPopup = ({
  onClose,
  open,
  resultName,
  fileDXF,
  fileXLSX,
}) => {
  const { viewOnly } = useUserContext();
  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      onClose={handleClose}
      open={open}
      sx={{
        ".MuiDialog-paper": {
          maxWidth: "440px",
          /*  width: "440px", */
          borderRadius: "12px",
          padding: "24px",
          background: "#FBFBFD",
        },
      }}
    >
      <DialogTitle>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
          }}
        >
          <IconDownloadFile width={"32px"} height={"32px"} stroke="#343745" />
          <Typography textAlign={"center"} fontSize={"18px"} fontWeight={600}>
            Download Options for {resultName}
          </Typography>
        </Box>{" "}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <IconClose stroke="#9e9e9e" width="14px" height="14px" />
      </IconButton>
      {/* <DialogContent> */}
      {(!fileDXF || !fileXLSX) && (
        <Box
          sx={{
            width: "100%",
            position: "relative",
            margin: "0 auto",
            padding: "0px 16px 16px 16px",
          }}
        >
          <Alert severity={"error"} sx={{ width: "100%", fontSize: "12px" }}>
            Unable to generate{" "}
            {!fileDXF && !fileXLSX
              ? ".dxf and .xlsx files"
              : !fileDXF
              ? ".dxf file"
              : ".xlsx file"}
            .
          </Alert>
        </Box>
      )}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          gap: "16px",
          alignItems: "center",
          justifyContent: "center",
          padding: "24px",
        }}
      >
        <AnchorDownloadButton
          key="dxf"
          disabled={viewOnly || !fileDXF}
          link={viewOnly ? null : fileDXF}
          title={"DXF"}
        />
        <AnchorDownloadButton
          key="xlsx"
          disabled={viewOnly || !fileXLSX}
          link={viewOnly ? null :  fileXLSX}
          title={"XLSX"}
        />
      </Box>
      {/* </DialogContent> */}
    </Dialog>
  );
};
